import { ReactNode } from 'react';
import { doesExist } from 'utils/tsHelpers';
import { ConditionSingleValueInputProps } from '../types';
import { ConditionSingleValueInput } from '../ConditionInput';

export const CountFilterInput = ({
  value,
  onChange,
  ...props
}: ConditionSingleValueInputProps<number> & { triggerTooltipContent?: ReactNode }) => {
  return (
    <ConditionSingleValueInput
      {...props}
      type="number"
      value={value}
      isEmpty={!doesExist(value)}
      onChange={onChange}
    />
  );
};
